import { render } from "./App.vue?vue&type=template&id=b2e896ee"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "D:\\千乐\\QL.Mini\\QL.Work\\QL.MiniInfo\\QL.MiniInfo.Template1\\QL.Back.Template1.1\\QL.Back.Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__